import $ = require('jquery');
import Modul, {UpdateResponse as ModuleUpdateResponse} from "../../Modul";
import {ModuleSectionData} from './payload';

interface UpdateResponseData<TPayload> extends ModuleUpdateResponse {
    payload: TPayload; //ModuleSectionPayload;
    renderWeight: number;
    hasReachedCriticalLimit: boolean;
    hasReachedMaximumLimit: boolean;
}

interface UpdateResponse<TPayload> {
    data: UpdateResponseData<TPayload>;
}

export function updateData<TPayload>(moduleId: number, data: TPayload) {
    let moduleType = Modul.getInstance(moduleId).getModuleType();
    return Promise.resolve<UpdateResponse<TPayload>>(
        $.ajax({
            url : systemurl + 'app/module/section/change-payload',
            data : {
                payload: data,
                moduleId: moduleId,
                moduleType
            },
            dataType : 'json',
            type : 'POST',
        })
    )
    .then(r => {
        Modul.getInstance(moduleId).doAfterSave(r.data);
        $(document).trigger('diy-editor-module-saved', moduleId);

        return r.data.payload;
    })
    .catch(r => handleServerError(r));
}

export function updateBackgroundImage<TPayload>(
    moduleId: number,
    imageId: number,
    imageType: string,
    successCallback: () => void,
    errorCallback: (error?: string) => void
) {
    let moduleType = Modul.getInstance(moduleId).getModuleType();
    return Promise.resolve<UpdateResponse<TPayload>>(
        $.ajax({
            type: 'POST',
            url: '/app/module/section/change-background-image',
            data: {
                moduleId: moduleId,
                imageId,
                imageType,
                moduleType
            },
            success: (response, status, jqXHR) => {
                if (response.success) {
                    successCallback();
                } else {
                    errorCallback();
                }
            },
            error: (jqXHR, status, errorThrown) => {
                errorCallback(errorThrown);
            }
        })
    )
    .then(response => {
        Modul.getInstance(moduleId).doAfterSave(response.data);
        $(document).trigger('diy-editor-module-saved', moduleId);

        return response.data.payload;
    })
    .catch(r => handleServerError(r));
}

export function saveTransformedBackgroundImage<TPayload>(
    moduleId: number,
    imageDataUrl: string
) {
    return Promise.resolve<UpdateResponse<TPayload>>(
        $.ajax({
            type: 'POST',
            url: '/app/module/section/edit-background-image',
            data: {
                moduleId: moduleId,
                transformedImageUrl: imageDataUrl
            }
        })
    )
    .then(response => {
        Modul.getInstance(moduleId).doAfterSave(response.data);
        $(document).trigger('diy-editor-module-saved', moduleId);

        return response.data.payload;
    })
    .catch(r => handleServerError(r));
}

export function addGroup(sectionModuleId: number) {
    return Promise.resolve<UpdateResponse<ModuleSectionData>>(
        $.ajax({
            url : systemurl + 'app/module/section/add-group',
            data : {
                moduleId: sectionModuleId
            },
            dataType : 'json',
            type : 'POST',
        })
    )
    .then(r => {
            Modul.handleLimitationsResponse(r.data);
            Modul.getInstance(sectionModuleId).doAfterSave(r.data);
            $(document).trigger('diy-editor-module-saved', sectionModuleId);

            return r.data.payload;
    })
    .catch(r => handleServerError(r));
}

export function delGroup(groupModuleId: number) {
    return Promise.resolve<UpdateResponse<ModuleSectionData>>(
        $.ajax({
            url : systemurl + 'app/module/section/remove-group',
            data : {
                moduleId: groupModuleId
            },
            dataType : 'json',
            type : 'POST',
        })
    )
    .then(r => {
        Modul.handleLimitationsResponse(r.data);

        let currentModule = Modul.getInstance(groupModuleId);
        let sectionModule = currentModule.getParentSection();

        currentModule.freezeOverlay(false);
        sectionModule.doAfterSave(r.data);
        currentModule.remove();
        $(document).trigger('diy-editor-module-deleted', groupModuleId);

        return r.data.payload;
    })
    .catch(r => handleServerError(r));
}

export function syncGroupsBackground(useBackroundFromModuleId: number) {
    return Promise.resolve<UpdateResponse<ModuleSectionData>>(
        $.ajax({
            url : systemurl + 'app/module/section/sync-group-background',
            data : {
                moduleId: useBackroundFromModuleId
            },
            dataType : 'json',
            type : 'POST',
        })
    )
    .then(r => {
        Modul.handleLimitationsResponse(r.data);

        let currentModule = Modul.getInstance(useBackroundFromModuleId);
        let sectionModule = currentModule.getParentSection();

        sectionModule.doAfterSave(r.data);
        $(document).trigger('diy-editor-module-saved', sectionModule.moduleId);

        return r.data.payload;
    })
    .catch(r => handleServerError(r));
}

function handleServerError(reason: any) {
    return Promise.reject(reason);
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/data/service.ts
 **/